import { render, staticRenderFns } from "./TeachingEvaluation.vue?vue&type=template&id=350177a8&scoped=true"
import script from "./TeachingEvaluation.vue?vue&type=script&lang=js"
export * from "./TeachingEvaluation.vue?vue&type=script&lang=js"
import style0 from "./TeachingEvaluation.vue?vue&type=style&index=0&id=350177a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_css-loader@6.11.0_webpack@5.98.0__lodash@4.17.21__s6l3nt2j5z2qyyvij7jcrz2r5m/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350177a8",
  null
  
)

export default component.exports